import {CHANGE_STEP} from './types';

function updateStep(nextStep) {
	return {
		type: CHANGE_STEP,
		payload: nextStep
	};
}

export {
	updateStep
}
export * from './types'